import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SparklesIcon } from 'lucide-react';
import { Divider } from '../ui/Divider';
export function Mechanism() {
  return <section className="py-20 px-6 bg-white" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <FadeIn data-id="element-78">
          <div className="text-center mb-10" data-id="element-79">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-80">
              La Solución: El Protocolo de Bio-fusión Latina
            </h2>
          </div>

          <div className="bg-brand-cream border border-brand-gold/30 rounded-3xl p-8 md:p-12 relative shadow-soft" data-id="element-81">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-brand-gold text-white p-3 rounded-full shadow-lg" data-id="element-82">
              <SparklesIcon className="w-8 h-8" data-id="element-83" />
            </div>

            <p className="text-xl text-center leading-relaxed mt-4" data-id="element-84">
              Es la unión de la{' '}
              <strong data-id="element-85">sabiduría ancestral de nuestras abuelas</strong>{' '}
              (ingredientes como la cúrcuma, el ajo y el caldo de huesos) con la{' '}
              <strong data-id="element-86">ciencia moderna de la nutrición anti-inflamatoria</strong>
              .
            </p>
            <p className="text-xl text-center leading-relaxed mt-6" data-id="element-87">
              No es una dieta, es una forma de{' '}
              <em data-id="element-88">"aceitar" tus bisagras naturales</em> desde adentro hacia
              afuera, usando preparaciones sencillas que ya conoces y amas.
            </p>
          </div>
        </FadeIn>
        <Divider data-id="element-89" />
      </div>
    </section>;
}